import { useCallback } from "react";
import useUser from "./useUser";
import { local_backend } from "../config";
import crypto from 'crypto-js';

const useSaveMessages = (threadId) => {

    const { user } = useUser();

    // Function to hash the username
    const hashUsername = (username) => {
        return crypto.SHA256(username).toString(crypto.enc.Hex);
    };
    const username = user?.account?.username;
    const saveMessages = useCallback(async (messages) => {
        if (!threadId || !username) {
            return;
        }

        try {

            let messageContent = [];

            messages.forEach(element => {
                if (element.role === "user") {
                    messageContent.push({
                        messageRequest: element.content,
                    })
                }

                if (element.role === "assistant") {
                    if (messageContent[messageContent.length - 1]) {
                        messageContent[messageContent.length - 1].messageResponse = element.originalContent;
                    }
                }
            });

            // Hash the username before sending to backend
            const hashedUsername = hashUsername(username);

            await fetch(`${local_backend}OpenAPI/SaveMessages`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    threadId: threadId,
                    userEmail: hashedUsername,
                    messageContent: [messageContent[messageContent.length - 1]]
                }),
            });


        } catch (err) {
            console.error("Message sending error:", err);
        }
    }, [threadId, username]);

    return { saveMessages };

};

export default useSaveMessages;
